"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Phenolicengravingtechnicaldetail() {
  const {
    ref: indexRef,
    isVisible: indexVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: manifestoRef,
    isVisible: manifestoVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ruleRef,
    isVisible: ruleVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const manifestoLines = [{
    text: "We believe industrial identification",
    italicWord: ""
  }, {
    text: "should be ",
    italicWord: "permanent."
  }, {
    text: "Not temporary. Not fragile. Not generic.",
    italicWord: ""
  }, {
    text: "The specs should be exact, the materials should be durable,",
    italicWord: ""
  }, {
    text: "and the compliance should be absolute — exactly as ",
    italicWord: "specified."
  }];
  return <section data-section-id="1604" id="phenolicengravingtechnicaldetail" className="relative overflow-hidden py-44 md:py-56" style={{
    backgroundColor: "#E8E4DC",
    color: "#0F1B2D"
  }}>
      <div className="relative mx-auto w-full max-w-4xl px-6 md:px-8">
        {}
        <div ref={indexRef} className={`transition-all duration-700 ease-out ${indexVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          <p className="font-mono uppercase" style={{
          color: "#0F1B2D",
          fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
          letterSpacing: "0.18em",
          lineHeight: 1
        }}>
            N&deg; 01 &mdash; Our Standard
          </p>
        </div>

        {}
        <div className="h-24 md:h-[120px]" aria-hidden="true" />

        {}
        <div ref={manifestoRef} className="relative">
          <h2 className="font-default" style={{
          color: "#0F1B2D",
          fontSize: "clamp(2.25rem, 5.4vw, 5.5rem)",
          fontWeight: 600,
          letterSpacing: "-0.025em",
          lineHeight: 1.08
        }}>
            {manifestoLines.map((line, i) => <span key={i} data-index={i} className={`block transition-all ease-out ${manifestoVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
            transitionDuration: "700ms",
            transitionDelay: `${i * 120}ms`,
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
          }}>
                {line.text}
                {line.italicWord && <em className="not-italic" style={{
              fontStyle: "italic",
              fontWeight: 600,
              color: "var(--primary)"
            }}>
                    {line.italicWord}
                  </em>}
              </span>)}
          </h2>
        </div>

        {}
        <div className="h-20 md:h-24" aria-hidden="true" />

        {}
        <div ref={ruleRef}>
          <div className="mt-8 md:mt-10">
            <p className={`font-mono uppercase transition-all ease-out ${ruleVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"}`} style={{
            color: "#0F1B2D",
            opacity: 0.7,
            fontSize: "clamp(0.75rem, 0.85vw, 0.875rem)",
            letterSpacing: "0.08em",
            lineHeight: 1.6,
            transitionDuration: "500ms",
            transitionDelay: "750ms",
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
          }}>EVERMARK INDUSTRIAL SOLUTIONS · PRECISION MARKING · EST. 2026</p>
          </div>
        </div>
      </div>
    </section>;
}